import { render, staticRenderFns } from "./AccessLightListItem.vue?vue&type=template&id=24beb9ec&"
import script from "./AccessLightListItem.vue?vue&type=script&lang=js&"
export * from "./AccessLightListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports